module.exports = __webpack_public_path__ + "img/homepageVector2.7b6ee4de.png";